$('.reviewsslider__container').slick({
  centerMode: true,
  variableWidth: true,
  arrows: true,
  prevArrow: "<button class='slick__button--prev'></button>",
  nextArrow: "<button class='slick__button--next'></button>",
});

